/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { TelegramCategoryControllerGetTreeMultilanguageQueryResponse } from '../types/TelegramCategoryControllerGetTreeMultilanguage.ts';

function getTelegramCategoryGetTreeMultilanguageUrl() {
  const res = { method: 'GET', url: `/api/telegram/category/tree/multilanguage` as const };
  return res;
}

/**
 * {@link /api/telegram/category/tree/multilanguage}
 */
export async function telegramCategoryGetTreeMultilanguage(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramCategoryControllerGetTreeMultilanguageQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: getTelegramCategoryGetTreeMultilanguageUrl().url.toString(), ...requestConfig });
  return res.data;
}
